<template>
  <div class="ac-card-content">
    <div class="replace-header-container">
      <button
        class="ac-close-button"
        @click="toggleModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="replace-header">
        Filter Replacement
      </div>
    </div>
    <div class="ac-body-container">
      <div class="ac-input-container">
        <div class="sac__font-16 semi-bold midnight margin-bottom-4">
          Select the date of the when this filter(s) was last replaced
        </div>
        <div class="ac-input-header">
          Last Replaced <span class="required">*</span>
        </div>
        <div class="date-container">
          <DatePicker
            v-model="lastReplacedDate"
            class="match-background"
            :max-date="today"
          />
        </div>
        <div
          v-if="errObj.lastReplacedDateErr"
          class="error-message"
        >
          {{ errObj.lastReplacedDateErr }}
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Quality <span class="required">*</span>
        </div>
        <SACDropdown
          placeholder="Select quality"
          :options="filterOptions"
          :value="filter.merv"
          field="merv"
          :change="changeFilterDetail"
          :error="errObj.mervErr"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="replaceFilter()"
      >
        Save
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Updating Filter Details"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import DatePicker from '@shared/components/DatePicker.vue';
import moment from 'moment';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACDropdown from '../../sac/SACDropdown.vue';

export default {
  name: 'ReplaceForm',
  components: {
    ProcessOverlay,
    SACDropdown,
    DatePicker,
  },
  mixins: [customerDetailMixin],
  props: {
    toggleModal: Function,
  },
  data() {
    return {
      selectedFilterBrand: '',
      filter: {},
      processing: false,
      errObj: {},
      today: moment().toDate(),
    };
  },
  computed: {
    lastReplacedDate: {
      get() {
        return this.filter.lastReplaced;
      },
      set(dateRange) {
        if (dateRange) {
          this.changeFilterDetail('lastReplaced', dateRange);
        }
      },
    },
  },
  mounted() {
    this.filter = _.cloneDeep(this.selectedFilter);
    if (!this.filter.brand) {
      this.filter.brand = '';
    }
    this.$store.dispatch('getFilterBrands');
  },
  methods: {
    changeFilterDetail(field, value) {
      this.filter = {
        ...this.filter,
        [field]: value,
      };
    },
    checkRequiredField() {
      this.errObj = {};
      if (!this.filter.merv) {
        this.errObj.mervErr = 'Quality is required.';
      }
      if (!this.filter.lastReplaced) {
        this.errObj.lastReplacedDateErr = 'Last Replaced Date is required';
      }
      return Object.keys(this.errObj).length;
    },
    async replaceFilter() {
      if (this.checkRequiredField() === 0) {
        const { filter } = this;
        this.processing = true;
        try {
          const res = await this.$store.dispatch('replaceCustomerFilter', {
            filter,
          });
          this.toggleModal(false);
          this.$store.dispatch('showSuccessToast', {
            header: 'Filter replace was successful.',
            message: `${filter?.location} filter was replaced`,
          });
        } catch (err) {
          console.error(err);
          this.$store.dispatch('showAlertToast', {
            message: 'There was an unexpected error replacing the filter. Please try again or contact support',
          });
        }
        this.processing = false;
      }
    },

  },
};
</script>
<style lang="scss">

.date-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 44px;
  width: 100%;
}

.error-message {
  color: $TOMATO100;
  font-size: 0.875rem;
  font-weight: 500;
  padding-left: 4px;
  margin-top: 5px;
}

.replace-header-container {
  padding: 29px 24px 19px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  border-bottom: 1px solid #EDF2FF;

  .replace-header {
    font-size: 1.25rem;
    font-weight: 500;
  }
}
</style>
